import script from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"

import "./message-plugin.vue?vue&type=style&index=0&id=723ea7d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723ea7d0"]])

export default __exports__